"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _Constant2 = require("../../Constant");

var _theme, _theme2, _theme3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &:hover {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  path {\n    stroke: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n  font-size: 1.5rem;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  background-color: initial;\n  cursor: pointer;\n  opacity: 0;\n  z-index: 1;\n  height: 2.6rem;\n  width: 2.6rem;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  margin-right: 10px;\n  height: 2.4rem;\n  width: 2.4rem;\n  border: 1px solid ", ";\n  border-radius: 50%;\n  ", ";\n\n  ", ":hover & {\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  min-height: 3.2rem;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  border-top: 1px solid ", ";\n  border-left: 1px solid ", ";\n  border-right: 1px solid ", ";\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n\n  &:focus-within {\n    outline: 4px solid ", ";\n    outline-offset: -4px;\n  }\n\n  .error {\n    margin-top: 8px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var stateColors = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant2.Themes.HOMEBRIDGE, _Constant2.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant2.Color.HOMEPOINT_ACCENT_BLUE), (0, _defineProperty2.default)(_theme, _Constant2.Themes.SYNERGY_ONE, _Constant2.Color.BLACK), (0, _defineProperty2.default)(_theme, "caliber", _Constant2.Color.CALIBER_PASTEL_BLUE), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.DARK_BLURPLE), (0, _defineProperty2.default)(_theme, _Constant2.Themes.GUARANTEED_RATE, _Constant2.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var focusColors = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant2.Themes.HOMEBRIDGE, _Constant2.Color.HOMEBRIDGE_YELLOW_LIGHT), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant2.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme2, _Constant2.Themes.SYNERGY_ONE, _Constant2.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant2.Color.CALIBER_PASTEL_BLUE), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.FOCUS), (0, _defineProperty2.default)(_theme2, _Constant2.Themes.GUARANTEED_RATE, _Constant2.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme2));
var selectedInput = (0, _styledTheming.default)('mode', (_theme3 = {}, (0, _defineProperty2.default)(_theme3, _Constant2.Themes.HOMEBRIDGE, _Constant2.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme3, "homepoint", _Constant2.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme3, _Constant2.Themes.SYNERGY_ONE, _Constant2.Color.BLACK), (0, _defineProperty2.default)(_theme3, "caliber", _Constant2.Color.CALIBER_BLUE_NEW), (0, _defineProperty2.default)(_theme3, "figure", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme3, "petersendean", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme3, "pella", _Constant.Color.PURPLE), (0, _defineProperty2.default)(_theme3, _Constant2.Themes.GUARANTEED_RATE, _Constant2.Color.GUARANTEED_RATE_ARROW_RED), _theme3));

var Wrapper = _styledComponents.default.div.attrs({
  className: 'gradient-radio-input-container'
})(_templateObject(), function (_ref) {
  var checked = _ref.checked;
  return checked ? selectedInput : '';
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? stateColors : _Constant.Color.GREY_4;
}, function (_ref3) {
  var checked = _ref3.checked;
  return checked ? stateColors : _Constant.Color.GREY_4;
}, function (_ref4) {
  var checked = _ref4.checked;
  return checked ? stateColors : _Constant.Color.GREY_4;
}, function (_ref5) {
  var checked = _ref5.checked;
  return checked ? stateColors : _Constant.Color.GREY_4;
}, focusColors);

var Checkbox = _styledComponents.default.span(_templateObject2(), function (_ref6) {
  var checked = _ref6.checked;
  return checked ? 'transparent' : _Constant.Color.GREY_4;
}, function (_ref7) {
  var checked = _ref7.checked;
  return checked ? "background-color: ".concat(_Constant.Color.WHITE) : '';
}, Wrapper, function (props) {
  return props.disabled ? '' : _Constant.Color.GREY_2;
}, function (props) {
  return props.disabled ? "\n    background-color: ".concat(_Constant.Color.GREY_4, ";\n    border: 1px solid ").concat(_Constant.Color.GREY_7, ";\n  ") : '';
});

var Radio = _styledComponents.default.input(_templateObject3());

var RadioLabel = _styledComponents.default.label(_templateObject4(), function (props) {
  return props.checked ? _Constant.Color.WHITE : _Constant.Color.BLACK_SOUL;
});

var RadioBase = _styledComponents.default.svg(_templateObject5());

var RadioCheckedBase = (0, _styledComponents.default)(RadioBase)(_templateObject6(), selectedInput);
var RadioInactiveBase = (0, _styledComponents.default)(RadioBase)(_templateObject7());
var RadioDisabledBase = (0, _styledComponents.default)(RadioBase)(_templateObject8());

var RadioChecked = function RadioChecked() {
  return /*#__PURE__*/_react.default.createElement(RadioCheckedBase, {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 1.21094L4 6.21094L0.999999 3.21094",
    stroke: "#190050",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var RadioInactive = function RadioInactive() {
  return /*#__PURE__*/_react.default.createElement(RadioInactiveBase, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: _Constant.Color.LIGHT_GREY_RADIO_BORDER,
    strokeWidth: "2"
  }));
};

var RadioDisabled = function RadioDisabled() {
  return /*#__PURE__*/_react.default.createElement(RadioDisabledBase, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: _Constant.Color.GREY_1,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: _Constant.Color.LIGHT_GREY_RADIO_BORDER,
    strokeWidth: "2"
  }));
};

var GradientRadioInput = function GradientRadioInput(_ref8) {
  var id = _ref8.id,
      label = _ref8.label,
      value = _ref8.value,
      checked = _ref8.checked,
      onChange = _ref8.onChange,
      disabled = _ref8.disabled,
      fsMask = _ref8.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref8, ["id", "label", "value", "checked", "onChange", "disabled", "fsMask"]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: 'radio',
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  });

  var RadioStatus = RadioInactive;

  if (disabled) {
    RadioStatus = RadioDisabled;
  } else if (checked) {
    RadioStatus = RadioChecked;
  }

  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    checked: checked,
    className: fsMask ? 'fs-mask' : ''
  }, /*#__PURE__*/_react.default.createElement(Radio, inputProps), /*#__PURE__*/_react.default.createElement(Checkbox, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(RadioStatus, null)), /*#__PURE__*/_react.default.createElement(RadioLabel, {
    htmlFor: id,
    checked: checked
  }, label));
};

GradientRadioInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,

  /** Value that controls the input */
  value: _propTypes.default.string,

  /** Whether or not the checkbox is checked */
  checked: _propTypes.default.bool,

  /** Function used to update the checked prop */
  onChange: _propTypes.default.func.isRequired,

  /** Whether or not to disable the checkbox */
  disabled: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
GradientRadioInput.defaultProps = {
  value: '',
  checked: false,
  disabled: false,
  fsMask: true
};
var _default = GradientRadioInput;
exports.default = _default;